import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ibcartao.css';
import Loading from "./components/loading"
import { sendEvent } from './Config';
import Footer from './components/Footer';

function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

const Approved = function () {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const leadIdRef = useRef(localStorage.getItem("lead_id"));

    const handleFormSubmit = async (e) => {
        e.preventDefault();
    }

    useEffect(() => {
        sendEvent(leadIdRef.current ?? false, "approved");

        if (typeof window !== "undefined") {
            if (window.location.hostname !== "localhost") {
                if (window.fbq) {
                    window.fbq('track', 'Lead');
                }

                if (window.gtag) {
                    window.gtag('event', 'conversion', {
                        'send_to': 'AW-18295695461/E_CBCKu-k88cEOXQiJRE',
                        'value': 1.0,
                        'currency': 'BRL'
                    });
                }
            }
        }
    }, []);

    return <>
        {isLoading && <Loading />}
        <div className='header flex items-center'>
            <div className='content flex items-center gap-x-4'>
                <div className='flex items-center w-auto border-r pr-4'>
                    <img src='/assets/img/logo-white.svg?t' className='logo' />
                </div>
                <div className='flex-1'>
                    <span className='subtitle'>Simulação de crédito BPF</span>
                </div>
            </div>
        </div>
        <div className="steps mt-5 flex gap-x-2">
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
        </div>
        <div className='container'>
            <form onSubmit={handleFormSubmit}>
                <div className='content mt-8'>
                    <h1>Boas notícias! A sua empresa cumpre os requisitos para o empréstimo do BPF.</h1>
                    <p className='mt-6 separator-bottom pb-5'>Inicie já a simulação e veja o valor que pode obter e o valor das suas prestações em apenas alguns segundos.</p>
                    <button onClick={(e) => {
                        /* if (!isMobile()) {
                            navigate(`/onboarding/view-pdf/${leadIdRef.current}`);
                        } else {
                            navigate("/onboarding/email");
                        } */

                        navigate(`/onboarding/view-pdf/${leadIdRef.current}`);
                    }} className='primary w-full mt-6'>Iniciar Simulação</button>
                    <p class="caption mt-12">Ao continuar, você concorda com os <a href="#">Termos de Uso e Política de Privacidade do BPF</a>.</p>
                </div>
            </form>
        </div>
    </>
}

export default Approved;